<mat-chip-listbox aria-label="status" class="log-status">
    <mat-chip-option *ngIf="this.status == 'Erro'" class="error" selected>Erro</mat-chip-option>
    <mat-chip-option *ngIf="this.status == 'Info'" class="warning" selected>Info</mat-chip-option>
    <mat-chip-option *ngIf="this.status == 'Sucesso'" class="success" selected>Sucesso</mat-chip-option>
</mat-chip-listbox>